import { render, staticRenderFns } from "./DomainsList.vue?vue&type=template&id=5a6bd94a&lang=pug&"
import script from "./DomainsList.vue?vue&type=script&lang=js&"
export * from "./DomainsList.vue?vue&type=script&lang=js&"
import style0 from "./DomainsList.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports